import { BaseService } from '../../../../../core/services/base.service';
import {
  CreateRecommendationInvitation,
  RecommendationInvitationCreated,
  SiteRecommendation,
} from '../models/site-recommendation.model';

const propagate = (error: Error): never => {
  throw error;
};

export class SiteRecommendationService {
  static list(): Promise<SiteRecommendation[]> {
    return BaseService.Get('/site-recommendations', propagate, false);
  }

  static invite(
    request: CreateRecommendationInvitation
  ): Promise<RecommendationInvitationCreated> {
    return BaseService.Post(
      '/site-recommendations/invitations',
      request,
      propagate,
      false
    );
  }

  static publish(id: string): Promise<SiteRecommendation> {
    return BaseService.Post(
      `/site-recommendations/${id}/publish`,
      {},
      propagate,
      false
    );
  }

  static unpublish(id: string): Promise<SiteRecommendation> {
    return BaseService.Post(
      `/site-recommendations/${id}/unpublish`,
      {},
      propagate,
      false
    );
  }

  static archive(id: string): Promise<SiteRecommendation> {
    return BaseService.Post(
      `/site-recommendations/${id}/archive`,
      {},
      propagate,
      false
    );
  }
}
